module.exports = __webpack_public_path__ + "static/media/MCC-brand.ca93ea2b.jpg";